import { connect } from 'react-redux'
import {
  setTheme,
  setScheme,
  setFontSize,
  toggleSettings,
  startAddWidgetToGeneralPage,
  setWidgetShopValue,
  setRefreshRate,
} from '@/store/actions/appSettings'
import {
  getSettingsOpenState,
  getThemeState,
  getSchemeState,
  getFontState,
  getWidgetShopValue,
  getUserData,
  getWidgets,
  getApplications,
  getRefreshRateState,
} from '@/store/selectors/appSettings'
import SettingsSidebar from '@/components/regions/sidebars/SettingsSidebar'

export default connect(
  (state) => ({
    isOpen: getSettingsOpenState(state),
    theme: getThemeState(state),
    scheme: getSchemeState(state),
    largeFont: getFontState(state),
    refreshRate: getRefreshRateState(state),
    widgetShopValue: getWidgetShopValue(state),
    user: getUserData(state),
    addedWidgets: getWidgets(state),
    addedApplications: getApplications(state),
  }),
  (dispatch) => ({
    setTheme: (theme) => dispatch(setTheme(theme)),
    setScheme: (scheme) => dispatch(setScheme(scheme)),
    setFontSize: (large) => dispatch(setFontSize(large)),
    setRefreshRate: (refreshRate) => dispatch(setRefreshRate(refreshRate)),
    setWidgetShopValue: (value) => dispatch(setWidgetShopValue(value)),
    onClose: () => dispatch(toggleSettings(false)),
    widgetsActions: {
      onAddWidget: (type, widgetType, large) => dispatch(startAddWidgetToGeneralPage(type, widgetType, large)),
    },
  }),
)(SettingsSidebar)
